<template>
  <div>
    <div class="container-buttons-report mb-1">
      <div class="align-content-end"></div>
      <div>
        <div class="noprint">
          <div class="d-flex ml-auto">
            <div
              class="d-flex"
              v-if="assessment_group_report && assessment_group_report.periods"
            >
              <div class="ml-auto mr-0 d-flex">
                <strong
                  class="mr-2 align-content-center"
                  style="font-size: 10pt"
                >
                  {{ $t("toolbar.reports.formative").toUpperCase() }}
                </strong>
                <b-form-checkbox
                  class="align-content-center"
                  v-model="assessment_switches_type"
                  switch
                >
                  <strong style="font-size: 10pt">{{
                    $t("toolbar.reports.summative").toUpperCase()
                  }}</strong>
                </b-form-checkbox>
              </div>
            </div>
            <GenericButtonDownload
              v-if="
                !is_loading &&
                assessment_group_report &&
                assessment_group_report.periods &&
                assessment_group_report.periods.length
              "
              :tooltip_text="$t('toolbar.reports.reportXlsx')"
              :click_button="DownloadExcel"
              :class="`ml-1`"
              :disabled_button="disabled_button_excel"
              :icon_excel="true"
            ></GenericButtonDownload>
          </div>
        </div>
      </div>
    </div>

    <!-- b-table -->
    <b-skeleton-table
      v-if="is_loading"
      :rows="9"
      :columns="10"
      :table-props="{ bordered: true, striped: true }"
    ></b-skeleton-table>
    <div>
      <b-table-simple
        bordered
        small
        responsive
        v-if="
          !is_loading &&
          assessment_group_report &&
          assessment_group_report.periods &&
          assessment_group_report.achievement_ranges_info
        "
        class="table-wrapper table-assesment"
      >
        <b-tbody>
          <b-tr>
            <b-th
              class="text-center align-middle primary-header"
              :colspan="
                3 +
                (assessment_group_report.achievement_ranges_info.length + 1) * 2
              "
            >
              <div class="d-flex align-items-center justify-content-between">
                <span class="text-center mx-auto">
                  {{
                    $getVisibleNames(
                      "manual.reporte.assessment_group_criteria",
                      false,
                      $t(
                        "toolbar.reports.assessmentGroupEvaluationCriteriaReportTitle",
                        {
                          evaluationCriteria: $getVisibleNames(
                            "manual.criterio_de_evaluacion",
                            true,
                            "Criterio de Evaluación"
                          ),
                          matter: $getVisibleNames(
                            "mesh.egressprofilematter",
                            false,
                            "Asignatura"
                          ),
                        }
                      )
                    ).toUpperCase()
                  }}
                </span>
                <VisibleColumns
                  v-if="displayList.length > 0"
                  :id_button="`col-display-1`"
                  :tooltip_text="''"
                >
                  <template #popover-title>
                    {{ $t("toolbar.reports.visualizeColumns") }}
                  </template>
                  <template #popover-content>
                    <template v-if="assessment_group_report != null">
                      <div class="visible_columns">
                        <template v-for="display in displayList">
                          <div
                            :key="'index' + display.index + 'id' + display.id"
                          >
                            <div class="noprint">
                              <b-form-checkbox
                                :id="`column-check-${display.index}`"
                                name="checkbox-1"
                                v-model="display.visible"
                                :disabled="
                                  displayList.filter(
                                    (a) => a.visible && a.id != display.id
                                  ).length < 1 && display.visible
                                "
                              >
                                {{ display.title }}
                                {{ display.order ? display.order : "" }}
                              </b-form-checkbox>
                            </div>
                          </div>
                        </template>
                      </div>
                    </template>
                  </template>
                </VisibleColumns>
              </div>
            </b-th>
          </b-tr>
          <template v-for="(period, index) in assessment_group_report.periods">
            <b-tr :key="`header-${period.id}-${index}`">
              <b-th
                class="text-center align-middle primary-header"
                :colspan="
                  3 +
                  (assessment_group_report.achievement_ranges_info.length + 1) *
                    2
                "
              >
                {{ getPeriodLabel(period.id) }}
              </b-th>
            </b-tr>
            <b-tr :key="`header2-${period.id}-${index}`">
              <b-th
                class="text-center align-middle secondary-header"
                rowspan="2"
                style="min-width: 80px"
                v-if="
                  displayList.some(
                    (x) =>
                      $equals(x.title, $t('toolbar.reports.raCe')) && x.visible
                  )
                "
              >
                {{ $t("toolbar.reports.raCe") }}
              </b-th>
              <b-th
                class="text-center align-middle secondary-header"
                rowspan="2"
                v-if="
                  displayList.some(
                    (x) =>
                      $equals(x.title, $t('toolbar.reports.statement')) &&
                      x.visible
                  )
                "
              >
                {{ $t("toolbar.reports.statement") }}
              </b-th>
              <template
                v-for="assessment_label in assessment_group_report.achievement_ranges_info"
              >
                <b-th
                  v-if="
                    displayList.some(
                      (x) =>
                        $equals(
                          `${x.title}`,
                          `${assessment_label.name.toUpperCase()}`
                        ) && x.visible
                    )
                  "
                  colspan="2"
                  v-b-tooltip.v-secondary.noninteractive="
                    `${assessment_label.start_achievement} ${
                      assessment_label.include_start_achievement ? '≤' : '<'
                    } X ${
                      assessment_label.include_finish_achievement ? '≤' : '<'
                    } ${assessment_label.finish_achievement}`
                  "
                  class="text-center align-middle secondary-header cursor-pointer"
                  :style="`background-color:${assessment_label.color} !important`"
                  :key="`header-assessment-${assessment_label.id}-${assessment_label.id}-${period.id}`"
                  :id="`header-assessment-top-${assessment_label.id}-${period.id}`"
                >
                  {{ assessment_label.name.toUpperCase() }}
                </b-th>
              </template>
              <b-th
                :key="`header-assessment-${period.id}`"
                colspan="2"
                v-if="
                  displayList.some(
                    (x) =>
                      $equals(
                        `${x.title}`,
                        $t('toolbar.reports.noRange').toUpperCase()
                      ) && x.visible
                  )
                "
                class="text-center align-middle secondary-header"
                >{{ $t("toolbar.reports.noRange").toUpperCase() }}</b-th
              >
              <b-th
                :key="`header-assessment-total-${period.id}`"
                rowspan="2"
                v-if="
                  displayList.some(
                    (x) =>
                      $equals(
                        `${x.title}`,
                        $t('toolbar.reports.total').toUpperCase()
                      ) && x.visible
                  )
                "
                class="text-center align-middle secondary-header"
                >{{ $t("toolbar.reports.total").toUpperCase() }}</b-th
              >
            </b-tr>
            <b-tr :key="`header3-${period.id}-${index}`">
              <template
                v-for="assessment_label in assessment_group_report.achievement_ranges_info"
              >
                <b-th
                  v-if="
                    displayList.some(
                      (x) =>
                        $equals(
                          `${x.title}`,
                          `${assessment_label.name.toUpperCase()}`
                        ) && x.visible
                    )
                  "
                  class="text-center align-middle secondary-header cursor-pointer"
                  v-b-tooltip.v-secondary.noninteractive="
                    $t('toolbar.reports.percentage')
                  "
                  :style="`background-color:${assessment_label.color} !important`"
                  :key="`header-assessment-3-%${assessment_label.id}-${period.id}`"
                  :id="`header-assessment-top-3-%${assessment_label.id}-${period.id}`"
                >
                  {{ $t("toolbar.reports.percentageSymbol") }}
                </b-th>
                <b-th
                  v-if="
                    displayList.some(
                      (x) =>
                        $equals(
                          `${x.title}`,
                          `${assessment_label.name.toUpperCase()}`
                        ) && x.visible
                    )
                  "
                  class="text-center align-middle secondary-header cursor-pointer"
                  v-b-tooltip.v-secondary.noninteractive="
                    $t('toolbar.reports.quantity')
                  "
                  :style="`background-color:${assessment_label.color} !important`"
                  :key="`header-assessment-3-cant${assessment_label.id}-${period.id}`"
                  :id="`header-assessment-top-3-cant${assessment_label.id}-${period.id}`"
                >
                  {{ $t("toolbar.reports.cant").toUpperCase() }}
                </b-th>
              </template>
              <b-th
                v-if="
                  displayList.some(
                    (x) =>
                      $equals(
                        `${x.title}`,
                        $t('toolbar.reports.noRange').toUpperCase()
                      ) && x.visible
                  )
                "
                class="text-center align-middle secondary-header cursor-pointer"
                v-b-tooltip.v-secondary.noninteractive="
                  $t('toolbar.reports.percentage')
                "
                :key="`header-assessment-4-%${period.id}`"
                :id="`header-assessment-top-4-%${period.id}`"
              >
                {{ $t("toolbar.reports.percentageSymbol") }}
              </b-th>
              <b-th
                v-if="
                  displayList.some(
                    (x) =>
                      $equals(
                        `${x.title}`,
                        $t('toolbar.reports.noRange').toUpperCase()
                      ) && x.visible
                  )
                "
                class="text-center align-middle secondary-header cursor-pointer"
                v-b-tooltip.v-secondary.noninteractive="
                  $t('toolbar.reports.quantity')
                "
                :key="`header-assessment-4-cant${period.id}`"
                :id="`header-assessment-top-4-cant${period.id}`"
              >
                {{ $t("toolbar.reports.cant").toUpperCase() }}
              </b-th>
            </b-tr>
            <template v-for="assessment in period.assessments">
              <b-tr :key="`assessment-${period.id}-${assessment.id}`">
                <!-- RA - CE -->
                <b-td
                  v-if="
                    displayList.some(
                      (x) =>
                        $equals(x.title, $t('toolbar.reports.raCe')) &&
                        x.visible
                    )
                  "
                  class="text-left"
                >
                  {{ getShortNameAssessment(assessment.id) }}
                </b-td>
                <!-- Enunciado -->
                <b-td
                  v-if="
                    displayList.some(
                      (x) =>
                        $equals(x.title, $t('toolbar.reports.statement')) &&
                        x.visible
                    )
                  "
                  class="text-left"
                >
                  {{ getFullSentenceAssessment(assessment.id) }}
                </b-td>
                <!-- Rangos -->
                <template
                  v-for="(
                    assessment_range, index
                  ) in assessment.achievement_ranges"
                >
                  <b-td
                    :key="`period:${period.id}-${assessment.id}-achievement_ranges${index}-%`"
                    v-if="
                      displayList.some(
                        (x) =>
                          $equals(
                            `${x.title}`,
                            `${getAssessmentRangeName(assessment_range.id)}`
                          ) && x.visible
                      )
                    "
                    class="text-center"
                  >
                    <div v-if="assessment_switches_type">
                      {{ assessment_range.range_percentage_summative | Round }}%
                    </div>
                    <div v-else>
                      {{ assessment_range.range_percentage_formative | Round }}%
                    </div>
                  </b-td>
                  <b-td
                    :key="`period:${period.id}-${assessment.id}-achievement_ranges${index}`"
                    v-if="
                      displayList.some(
                        (x) =>
                          $equals(
                            `${x.title}`,
                            `${getAssessmentRangeName(assessment_range.id)}`
                          ) && x.visible
                      )
                    "
                    class="text-center"
                  >
                    <div v-if="assessment_switches_type">
                      {{ assessment_range.range_count_summative | Round }}
                    </div>
                    <div v-else>
                      {{ assessment_range.range_count_formative | Round }}
                    </div>
                  </b-td>
                </template>
                <!-- SIN RANGO -->
                <b-td
                  :key="`period:${period.id}-${assessment.id}-%`"
                  class="text-center"
                  v-if="
                    displayList.some(
                      (x) =>
                        $equals(
                          `${x.title}`,
                          $t('toolbar.reports.noRange').toUpperCase()
                        ) && x.visible
                    )
                  "
                >
                  <div v-if="assessment_switches_type">
                    {{ assessment.unregistered_percentage_summative | Round }}%
                  </div>
                  <div v-else>
                    {{ assessment.unregistered_percentage_formative | Round }}%
                  </div>
                </b-td>
                <b-td
                  :key="`period:${period.id}-${assessment.id}-Cant`"
                  class="text-center"
                  v-if="
                    displayList.some(
                      (x) =>
                        $equals(
                          `${x.title}`,
                          $t('toolbar.reports.noRange').toUpperCase()
                        ) && x.visible
                    )
                  "
                >
                  <div v-if="assessment_switches_type">
                    {{ assessment.unregistered_count_summative | Round }}
                  </div>
                  <div v-else>
                    {{ assessment.unregistered_count_formative | Round }}
                  </div>
                </b-td>
                <b-td
                  class="text-center"
                  v-if="
                    displayList.some(
                      (x) =>
                        $equals(
                          `${x.title}`,
                          $t('toolbar.reports.total').toUpperCase()
                        ) && x.visible
                    )
                  "
                  >{{ getTotalAssessment(assessment) | Round }}
                </b-td>
              </b-tr>
            </template>
          </template>
          <b-tr v-if="assessment_group_report.periods.length == 0">
            <b-td :colspan="displayList.length">
              {{ $t("toolbar.reports.noDataToDisplay") }}
            </b-td>
          </b-tr>
        </b-tbody>
      </b-table-simple>
      <!-- Grafico -->
      <GenericGraphic
        v-if="periodOptions.length > 0"
        :labels="chartLabels"
        :datasets="chartDatasets"
        :legend_labels="legendLabels"
        :title_graphic="
          $t('toolbar.reports.assessmentGroupEvaluationCriteriaReportTitle', {
            evaluationCriteria: $getVisibleNames(
              'Criterio de Evaluación',
              true,
              'Criterio de Evaluación'
            ),
            matter: $getVisibleNames(
              'mesh.egressprofilematter',
              false,
              'Asignatura'
            ),
          }).toUpperCase()
        "
        :total_students="totalStudents"
        :label_y_axis="$t('toolbar.reports.numberOfStudents')"
        :title_table_circular="$t('toolbar.reports.assessment')"
        :selected_assessment="selected_assessment"
      >
        <template #selector>
          <div class="d-flex">
            <!-- Selector de sección -->
            <b-form-select
              id="periodSelector"
              v-model="selected_period"
              :options="periodOptions"
              @change="updatePeriod"
              class="select-period mr-3"
            ></b-form-select>
            <b-form-select
              v-if="selected_period != null"
              id="assessmentSelector"
              v-model="selected_assessment"
              :options="assessmentOptions"
              @change="updateAssessment"
            ></b-form-select>
            <b-tooltip
              v-if="
                selected_assessment != 'compare_all' &&
                getCurrentTooltip(selected_assessment)
              "
              target="assessmentSelector"
              triggers="hover"
              placement="right"
              boundary="window"
            >
              {{ getCurrentTooltip(selected_assessment) }}
            </b-tooltip>
          </div>
        </template>
      </GenericGraphic>
    </div>
  </div>
</template>

<script>
// import * as names from "@/store/names";
import { mapGetters } from "vuex";
import {
  showLoadingAlert,
  downloadFileFromResponse,
  EventBus,
} from "@/utils/utils";
export default {
  name: "AssessmentGroupEvaluationCriteriaTable",
  components: {
    VisibleColumns: () =>
      import("@/components/reusable/Buttons/VisibleColumns"),
    GenericButtonDownload: () =>
      import("@/components/reusable/Buttons/GenericButtonDownload"),
    GenericGraphic: () => import("@/components/reusable/GenericGraphic"),
  },
  props: {
    egress_profile: {
      type: Object,
      required: true,
    },
    egress_profile_matter: {
      type: Object,
      required: true,
    },
    achievement_range_group: {
      type: [Number, null],
      required: false,
      default: null,
    },
    campuses_: {
      type: Array,
      required: true,
    },
    periods_: {
      type: Array,
    },
    study_units_: {
      type: Array,
    },
    student_status_: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      is_loading: false, // Variable para mostrar "skeletons"
      disabled_button_excel: false,
      assessment_group_report: [],
      displayList: [],
      assessment_switches_type: true,
      selected_assessment: "compare_all", // Variable para guardar assessment del selector.
      selected_period: null,
    };
  },
  computed: {
    ...mapGetters({
      institution: "getInstitution",
    }),
    isOnTrack() {
      const student_status_ids = this.student_status_.map((x) => x.id);
      if (student_status_ids.includes(1) && student_status_ids.includes(2))
        return null;
      else if (student_status_ids.includes(1)) return true;
      else if (student_status_ids.includes(2)) return false;
      return null;
    },
    periodOptions() {
      if (!this.assessment_group_report?.periods_info) return [];

      const options = [];

      options.push({
        value: null,
        text: this.$t("toolbar.reports.selectPeriod"),
      });

      this.assessment_group_report.periods_info.forEach((x) => {
        options.push({
          value: x.id,
          text: x.name,
        });
      });
      return options;
    },
    assessmentOptions() {
      if (
        !this.assessment_group_report?.periods ||
        !this.assessment_group_report?.assessments_info ||
        !this.selected_period
      )
        return [];

      // Buscar el período seleccionado
      const selectedPeriod = this.assessment_group_report.periods.find(
        (x) => x.id == this.selected_period
      );

      if (!selectedPeriod) return [];

      // Obtener los IDs de assessments del período seleccionado
      const periodAssessmentIds = selectedPeriod.assessments.map((a) => a.id);

      // Filtrar assessments_info basado en los IDs del período
      const periodAssessments =
        this.assessment_group_report.assessments_info.filter((x) =>
          periodAssessmentIds.includes(x.id)
        );

      // Generar las opciones
      const options = periodAssessments.map((x) => ({
        value: x.id,
        text: x.assessment_short_text.trim(),
      }));

      // Añadir opción "Comparar todos"
      options.push({
        value: "compare_all",
        text: this.$t("toolbar.reports.viewAllAssessments"),
      });

      return options;
    },
    totalStudents() {
      if (
        !this.assessment_group_report?.assessments_info ||
        !this.selected_period
      )
        return 0;

      const selectedPeriod = this.assessment_group_report.periods.find(
        (x) => x.id == this.selected_period
      );

      return selectedPeriod?.evaluatee_count || 0;
    },
    chartLabels() {
      if (
        !this.assessment_group_report ||
        !this.assessment_group_report.assessments_info ||
        !this.assessment_group_report.periods
      ) {
        return [];
      }

      // Buscar el período seleccionado
      const selectedPeriod = this.assessment_group_report.periods.find(
        (x) => x.id == this.selected_period
      );
      if (!selectedPeriod?.assessments) return [];

      if (this.selected_assessment == "compare_all") {
        return selectedPeriod.assessments.map((assessment) => {
          // Buscar la información completa del assessment
          const assessmentInfo =
            this.assessment_group_report.assessments_info?.find(
              (a) => a.id === assessment.id
            );
          return (
            assessmentInfo?.assessment_short_text ||
            `Assessment ${assessment.id}`
          );
        });
      }

      // Para la opción individual, mostrar el nombre del assessment y el order
      if (this.selected_assessment) {
        const selectedAssessment = selectedPeriod.assessments.find(
          (a) => a.id == this.selected_assessment
        );

        if (selectedAssessment) {
          const assessmentInfo =
            this.assessment_group_report.assessments_info?.find(
              (a) => a.id === selectedAssessment.id
            );
          return assessmentInfo ? [assessmentInfo.assessment_short_text] : [];
        }
      }
      return [];
    },

    chartDatasets() {
      if (
        !this.assessment_group_report?.achievement_ranges_info ||
        !this.selected_period ||
        !this.selected_assessment
      ) {
        return [];
      }

      // Buscar el período seleccionado
      const selectedPeriod = this.assessment_group_report.periods.find(
        (period) => period.id == this.selected_period
      );

      if (!selectedPeriod?.assessments) return [];

      const datasets = [];

      // Si se selecciona "Comparar todos"
      if (this.selected_assessment === "compare_all") {
        // Crear un dataset por cada achievement_range
        this.assessment_group_report.achievement_ranges_info.forEach(
          (range) => {
            const data = selectedPeriod.assessments.map((assessment) => {
              const matchingRange = assessment.achievement_ranges.find(
                (x) => x.id == range.id
              );
              return matchingRange
                ? this.assessment_switches_type
                  ? matchingRange.range_count_summative
                  : matchingRange.range_count_formative
                : 0;
            });

            datasets.push({
              label: range.name, // Nombre del rango
              data: data, // Datos para el gráfico
              backgroundColor: range.color, // Color del achievement_range
            });
          }
        );

        // Agregar dataset para los sin registro
        const unregisteredData = selectedPeriod.assessments.map((assessment) =>
          this.assessment_switches_type
            ? assessment.unregistered_count_summative
            : assessment.unregistered_count_formative
        );

        datasets.push({
          label: this.$t("toolbar.reports.noRange"), // Etiqueta para los sin Registro
          data: unregisteredData, // Datos de sin Registro
          backgroundColor: "#cccccc", // Color gris para diferenciar
        });
      } else {
        // Si se selecciona una opcion individual
        const selectedAssessment = selectedPeriod.assessments.find(
          (a) => a.id == this.selected_assessment
        );

        if (selectedAssessment) {
          // Crear un dataset por cada achievement_range
          this.assessment_group_report.achievement_ranges_info.forEach(
            (range) => {
              const matchingRange = selectedAssessment.achievement_ranges.find(
                (x) => x.id == range.id
              );

              datasets.push({
                label: range.name,
                data: [
                  matchingRange
                    ? this.assessment_switches_type
                      ? matchingRange.range_count_summative
                      : matchingRange.range_count_formative
                    : 0,
                ],
                backgroundColor: range.color,
              });
            }
          );

          // Agregar dataset para los sin registro
          datasets.push({
            label: this.$t("toolbar.reports.noRange"),
            data: [
              this.assessment_switches_type
                ? selectedAssessment.unregistered_count_summative
                : selectedAssessment.unregistered_count_formative,
            ],
            backgroundColor: "#cccccc",
          });
        }
      }

      return datasets;
    },
    legendLabels() {
      if (
        this.assessment_group_report &&
        this.assessment_group_report.achievement_ranges_info
      ) {
        // Devuelve los nombres de los rangos
        const labels = this.assessment_group_report.achievement_ranges_info.map(
          (x) => ({
            label: x.name,
            color: x.color,
          })
        );

        // Añadir la etiqueta para los sin Registro
        labels.push({
          label: this.$t("toolbar.reports.noRange"), // Etiqueta para los sin Registro
          color: "#cccccc", // Color gris para los sin Registro
        });

        return labels;
      }
      return [];
    },
  },
  methods: {
    getCurrentTooltip(assessmentId) {
      if (assessmentId == "compare_all" || !assessmentId) return null;
      const assessment = this.assessment_group_report?.assessments_info.find(
        (x) => x.id == assessmentId
      );
      return assessment?.full_sentence || null;
    },
    updateAssessment(selectedId) {
      this.selected_assessment = selectedId;
    },
    updatePeriod(selectedId) {
      this.selected_period = selectedId;
      this.selected_assessment = "compare_all";
    },
    getPeriodLabel(period_id) {
      if (
        !this.assessment_group_report ||
        this.assessment_group_report.length == 0
      )
        return "";
      const period_name = this.assessment_group_report.periods_info.find(
        (x) => x.id == period_id
      );
      if (period_name) return period_name.name;
      return "";
    },
    getShortNameAssessment(assessment_id) {
      if (
        !this.assessment_group_report ||
        this.assessment_group_report.length == 0
      )
        return "";
      const assessment = this.assessment_group_report.assessments_info.find(
        (x) => x.id == assessment_id
      );
      if (assessment) return assessment.assessment_short_text;
      return "";
    },
    getAssessmentRangeName(assessment_range_id) {
      if (
        !this.assessment_group_report ||
        this.assessment_group_report.length == 0
      )
        return "";
      const assessment =
        this.assessment_group_report.achievement_ranges_info.find(
          (x) => x.id == assessment_range_id
        );
      if (assessment) return assessment.name.toUpperCase();
      return "";
    },
    getFullSentenceAssessment(assessment_id) {
      if (
        !this.assessment_group_report ||
        this.assessment_group_report.length == 0
      )
        return "";
      const assessment = this.assessment_group_report.assessments_info.find(
        (x) => x.id == assessment_id
      );
      if (assessment) return assessment.full_sentence;
      return "";
    },
    getTotalAssessment(assessment) {
      let count = 0;
      if (this.assessment_switches_type) {
        count += assessment.unregistered_count_summative;
        count += assessment.achievement_ranges.reduce((accumulator, x) => {
          return accumulator + x.range_count_summative;
        }, 0);
      } else {
        count += assessment.unregistered_count_formative;
        count += assessment.achievement_ranges.reduce((accumulator, x) => {
          return accumulator + x.range_count_formative;
        }, 0);
      }
      return count;
    },
    completeDisplayList(response) {
      this.displayList = [
        {
          index: 0,
          id: this.$t("toolbar.reports.raCe"),
          title: this.$t("toolbar.reports.raCe"),
          visible: true,
        },
        {
          index: 1,
          id: this.$t("toolbar.reports.statement"),
          title: this.$t("toolbar.reports.statement"),
          visible: true,
        },
      ];

      let display_index = this.displayList.length;
      if (
        response.achievement_ranges_info &&
        response.achievement_ranges_info.length > 0
      ) {
        response.achievement_ranges_info.forEach((element) => {
          this.displayList.push({
            index: display_index,
            id: element.id,
            title: `${element.name.toUpperCase()}`,
            order: "",
            visible: true,
          });
          display_index += 1;
        });
        this.displayList.push({
          index: display_index,
          id: this.$t("toolbar.reports.noRange").toUpperCase(),
          title: this.$t("toolbar.reports.noRange").toUpperCase(),
          order: "",
          visible: true,
        });
        display_index += 1;
        this.displayList.push({
          index: display_index,
          id: this.$t("toolbar.reports.total").toUpperCase(),
          title: this.$t("toolbar.reports.total").toUpperCase(),
          order: "",
          visible: true,
        });
      }
    },
    getAssessmentRange() {
      this.is_loading = true;
      this.displayList = [];
      this.$restful
        .Post(`/assessment2/group_ecmi_report/`, {
          egress_profile_matter: this.egress_profile_matter.id,
          periods: this.periods_.map((x) => x.id),
          achievement_range_group: this.achievement_range_group,
          assessments: this.study_units_
            .filter((x) => x.assessment != null)
            .map((x) => x.assessment),
          is_on_track: this.isOnTrack,
        })
        .then((response) => {
          this.assessment_group_report = response;
          this.completeDisplayList(response);
          this.$swal.close();
          EventBus.$emit("report_request_finished");
          this.is_loading = false;
        })
        .catch(() => {
          this.is_loading = false;
          this.$swal.close();
          EventBus.$emit("report_request_finished");
          this.$swal.fire(
            this.$t("reusable.common.error"),
            this.$t("reusable.common.problemGenerating"),
            "error"
          );
        });
    },
    DownloadExcel() {
      this.disabled_button_excel = true;

      showLoadingAlert(
        this.$t("reusable.common.generatingExcel"),
        this.$t("reusable.common.pleaseWaitFile")
      );
      this.$restful
        .Post(
          `assessment2/excel_report_group_ecmi_report/`,
          {
            egress_profile_matter: this.egress_profile_matter.id,
            periods: this.periods_.map((x) => x.id),
            achievement_range_group: this.achievement_range_group,
            assessments: this.study_units_
              .filter((x) => x.assessment != null)
              .map((x) => x.assessment),
            is_on_track: this.isOnTrack,
          },
          {
            responseType: "blob",
          }
        )
        .then((response) => {
          this.$swal.close();
          if (response) {
            downloadFileFromResponse(
              response,
              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
              () => {
                this.disabled_button_excel = false;
              },
              () => {
                this.disabled_button_excel = false;
                this.$swal.fire(
                  this.$t("reusable.common.error"),
                  this.$t("reusable.common.downloadError"),
                  "error"
                );
              }
            );
          } else {
            this.disabled_button_excel = false;
            this.$swal.fire(
              this.$t("reusable.common.error"),
              this.$t("reusable.common.generateError"),
              "error"
            );
          }
        })
        .catch(() => {
          this.disabled_button_excel = false;
          this.$swal.close();
          this.$swal.fire(
            this.$t("reusable.common.error"),
            this.$t("reusable.common.problemGenerating"),
            "error"
          );
        });
    },
  },
  created() {
    this.getAssessmentRange();
  },
};
</script>

<style scoped>
.select-period {
  width: auto;
}
.container-buttons-report {
  display: flex;
  justify-content: right;
}
.primary-header {
  background-color: var(--kl-color-accent-medium) !important;
  color: white;
}
.secondary-header {
  background: var(--kl-table-header-bg) !important;
  color: var(--kl-table-header-text);
}
.col-display-1,
.col-display-2 {
  min-width: 200px;
  margin-left: 2em;
  background-color: var(--kl-primary-button-color) !important;
  color: #fff;
}
.col-display-1:hover,
.col-display-2:hover {
  background-color: var(--kl-primary-button-hover-color) !important;
  transition: all 0.3s;
}
.truncated-text {
  white-space: nowrap; /* Evita el salto de línea */
  overflow: hidden; /* Oculta el contenido que se desborda */
  text-overflow: ellipsis; /* Agrega "..." al final */
  width: 100%; /* Asegura que no sobrepase el contenedor */
}
.visible_columns {
  max-height: 300px;
  overflow: auto;
}
.cursor-pointer {
  cursor: help;
}

/* Table wrapper styles with max height and scroll */
.table-wrapper {
  max-width: 100%;
  max-height: 80vh;
  overflow: auto;
  border: 1px solid var(--kl-table-border);
  border-radius: 8px;
  margin: 20px 0;
}

@media (max-width: 768px) {
  .table-assesment-range-table {
    width: 100%;
    min-width: 600px;
    border-collapse: collapse; /* Evita que las celdas se sobrepongan */
  }
  .table-assesment {
    width: 100%;
    min-width: 800px;
    border-collapse: collapse; /* Evita que las celdas se sobrepongan */
  }
}
/* .table-assesment-print-table {
  display: none;
} */

@media print {
  .table-wrapper {
    max-height: none !important;
    overflow: visible !important;
    border: none !important;
  }

  .table-assesment-print-table {
    display: block;
  }
  .badge {
    border: none;
  }
}
</style>

